var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MainMenu"}},[(_vm.$store.state.HCRoutes.permissions)?_c('el-menu',{attrs:{"mode":"horizontal"}},_vm._l((_vm.MenuList),function(e,i){return _c('el-menu-item',{key:i,class:_vm.setCurrent(e),on:{"click":function($event){return _vm.RouteGo(e.name)}}},[_vm._v(_vm._s(e.title))])}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e7bcb3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu/index.vue
// module id = null
// module chunks = 